import { AxiosResponse } from 'axios'
import { RFC7807Error } from 'shared/api/constants/RFC7807'
import { ErrorResponseContentInterface } from 'shared/types/error-response-content-interface'

export class UnprocessableContentError extends Error {
  public status: number
  public data: RFC7807Error | ErrorResponseContentInterface

  constructor(response: AxiosResponse) {
    super()

    this.name = 'UnprocessableContentError'
    this.status = response.status
    this.data = response.data
  }
}
